import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'emPhone'})
export class PhonePipe implements PipeTransform {
  transform(value: string | undefined, ...args: any[]): string {
    if (!value) {
      return '--';
    }
    return `(${value.substring(0, 3)})\u00A0${value.substring(3, 6)}\u2011${value.substring(6, 10)}`;
  }
}
